import React from 'react'
import { computed, observable } from 'mobx'
import { observer } from 'mobx-react'
import {
  i18nTranslate,
  isExpressCheckout,
  isSubscriptionOverrideCheckoutPage,
  isB2BAccount,
  isB2BUser,
  trackEnhancedCheckout,
  trackPincodeError,
  isPatchAddressAfterCartSuccess,
  isFeatureEnabled,
  isStateValidationSkippedForCountry,
  isGPSEnabled,
} from 'src/utils'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import {
  cartContainer,
  checkoutContainer,
  customerContainer,
  addressContainer,
  accountsContainer,
  accountsAddressContainer,
  nlxxConfigContainer,
} from 'src/models'
import { storeContainer } from 'src/models/Store'
import {
  toastState,
  overlayState,
  ShippingAddressListWithForm,
  AddressValidation,
} from 'src/views/components'
import { pageNames } from 'src/routes/pathParams'
import {
  handleAddressValidation,
  isToShowLegalAddressOptionInAddressForm,
} from 'src/deps'
import {
  hasLegalAddressPreference,
  normalizeLegalAddressPreference,
} from 'src/views/components/ShippingAddressListWithForm/legalAddressPreference'
import { isPromoWalletEnabled } from 'src/views/components/CheckoutAccordions/deps'
import { showAllPromoCodesInCheckout } from 'config/appConfig/configUtils'
import { isToHaveOptionalPhoneSchema } from 'src/views/addresses/addressUtils'
import {
  isPostalCodeBlank,
  isPostalCodeOptionalByShippingAddressForm,
  removeShippingAddressFormValidationMeta,
  shouldMakeLegacyAddressValidationApiCall,
  wasValidatedByShippingAddressForm,
} from 'src/views/components/CommonFormForCS/shippingAddressFormValidation'

@observer
class ShippingAccordion extends React.Component {
  @observable addressList = null
  @observable isAddressFromProfile = false
  @observable isToDisableShippingContinueBtn = false
  @observable shippingMethodAdded = false

  updateAddressAfterCartSuccess = null
  redirectToSubscriptionCartTimer = null
  redirectToCartTimer = null

  constructor(props) {
    super(props)
    this.state = {
      show: false,
      flag: false,
      recommendations: [],
      formDataEnter: {},
      selectedAddress: {},
      addressInvalidFlag: false,
      isAddressNotAdded: false,
    }
  }

  async componentDidMount() {
    if (
      !nlxxConfigContainer.nlxxConfigStoreId ||
      nlxxConfigContainer.nlxxConfigStoreId !== storeContainer.activeStoreId
    ) {
      nlxxConfigContainer.loadNLXXConfig()
    }
    this.getAddressFromProfile()

    // set before any await so children never paint the pre-default value
    let isToShowLegalAddressChangesInCheckout =
      isToShowLegalAddressOptionInAddressForm() || false
    if (
      isToShowLegalAddressChangesInCheckout &&
      !isExpressCheckout() &&
      !checkoutContainer.isLegalAddressPreferenceSet
    ) {
      checkoutContainer.isLegalAddressSameAsShipping = 'true'
    }

    if (cartContainer?.cartResponse?.payments) {
      if (!isExpressCheckout()) {
        await checkoutContainer.deletePayment()
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isRegisteredUser !== this.props.isRegisteredUser) {
      this.getAddressFromProfile()
    }
  }

  componentWillUnmount() {
    if (this.redirectToSubscriptionCartTimer) {
      clearTimeout(this.redirectToSubscriptionCartTimer)
    }
    if (this.redirectToCartTimer) {
      clearTimeout(this.redirectToCartTimer)
    }
  }

  // modifyAndSetAddressForB2B = async response => {
  //   // ----------------below will happen in ShippingAddressListWithForm ----------------
  //   // if cart contains address,
  //   // cart address will be compared to addressList
  //   // if cart address matches with addressList, radio button will be selected
  //   // else default address will be selected

  //   // here if we dont have address in cart
  //   // and if  BUSINESS_RELATIONSHIP is B2B
  //   // make the below address as default address
  //   if (this.initiallySelectedAddress === '' && isB2BAccount()) {
  //     const address = accountsContainer?.profileResponse?.addresses?.['0'] || ''
  //     const newAddress =
  //       address === '' ? await this.makeAccountCalls() : address
  //     if (
  //       newAddress.country &&
  //       (newAddress.country.toLowerCase() === 'us' ||
  //         newAddress.country.toLowerCase() === 'united states')
  //     ) {
  //       newAddress.country = 'US'
  //       this.initiallySelectedAddress = newAddress
  //     }
  //   }
  //   this.addressList = response
  // }

  getAddressList = async () => {
    if (isB2BAccount() && isB2BUser()) {
      const accountAddressResponse = accountsAddressContainer?.addressData || []
      // this.modifyAndSetAddressForB2B(accountAddressResponse)
      this.addressList = accountAddressResponse
    } else {
      const customerAddressResponse = await addressContainer.getProfileAddress()
      this.addressList =
        customerAddressResponse && customerAddressResponse.length
          ? customerAddressResponse
          : []
    }
  }
  @computed
  get cartUpdatedAddress() {
    return cartContainer.cartResponse?.deliveryDetails?.address || ''
  }

  getAddressFromProfile = async () => {
    const addressToSelectOrPrefill =
      cartContainer.cartResponse?.deliveryDetails?.address || ''
    checkoutContainer.initiallySelectedAddress = addressToSelectOrPrefill
    if (this.props.isRegisteredUser) {
      this.getAddressList()
    } else {
      this.addressList = []
    }
    this.isAddressFromProfile = true
  }

  handleModal = async (formData, reqBody) => {
    this.isToDisableShippingContinueBtn = true
    this.updateAddressAfterCartSuccess = null
    let formDataTemp = {
      ...formData,
      shippingInstructions: reqBody?.shippingInstructions || '',
      setDefaultAddress:
        reqBody?.setDefaultAddress || reqBody?.isDefault || false,
    }
    let isToShowLegalAddressChangesInCheckout =
      isToShowLegalAddressOptionInAddressForm() || false
    if (
      isToShowLegalAddressChangesInCheckout &&
      hasLegalAddressPreference(formData?.legalAddressSameAsShippingAddress)
    ) {
      checkoutContainer.isLegalAddressSameAsShipping =
        normalizeLegalAddressPreference(
          formData?.legalAddressSameAsShippingAddress
        )
      checkoutContainer.isLegalAddressPreferenceSet = true
    }

    const isToMakeAddressValidationApi =
      shouldMakeLegacyAddressValidationApiCall(
        formData,
        storeContainer?.defaultShippingRegion
      )
    reqBody = removeShippingAddressFormValidationMeta(reqBody)
    if (isToMakeAddressValidationApi) {
      const res = await addressContainer.validateAddress(reqBody)
      if (res?.code === 'ADCOVAL0003') {
        this.setState({
          show: true,
          addressInvalidFlag: true,
          recommendations: [{ ...formDataTemp }, []],
          formDataEnter: { ...formDataTemp },
        })
        if (isExpressCheckout()) {
          this.setState({ isAddressNotAdded: true })
        }
      } else if (res?.code == 'ONESOURCE_ADPLGIN_VAL_ERROR') {
        this.setState({
          show: false,
        })
        if (isExpressCheckout()) {
          this.setState({ isAddressNotAdded: true })
        }
        toastState.setToastMessage(
          i18nTranslate('address.NotAdded', 'Address not added')
        )
        this.isToDisableShippingContinueBtn = false
        return
      } else if (checkoutContainer.isSuccessResponse(res)) {
        let recommendationAddress =
          res?.address?.validationDetails?.[0]?.recommendations || []
        let firstAddress = recommendationAddress?.[0] || {}
        if (
          Object.keys(firstAddress)?.length > 0 &&
          handleAddressValidation(formDataTemp, firstAddress)
        ) {
          this.setState({ addressInvalidFlag: false })
          // const validationcode = res.address.validationDetails[0].responseCode
          this.setState({
            show: true,
            recommendations: [
              { ...formDataTemp },
              ...res?.address?.validationDetails?.[0]?.recommendations,
            ],
            formDataEnter: { ...formDataTemp },
          })
          if (isExpressCheckout()) {
            this.setState({
              isAddressNotAdded: false,
            })
          }
        } else {
          this.handleClickOnPro(formDataTemp)
        }
      } else {
        this.setState({
          show: false,
        })
        if (isExpressCheckout()) {
          this.setState({ isAddressNotAdded: true })
        }
        toastState.setToastMessage(
          i18nTranslate('address.NotAdded', 'Address not added')
        )
        this.isToDisableShippingContinueBtn = false
        return
      }
    } else {
      this.handleClickOnPro(formDataTemp)
    }
    this.isToDisableShippingContinueBtn = false
  }

  makeAccountCalls = async () => {
    const accountId = customerContainer.profileResponse?.accounts?.id || ''
    const response = await accountsContainer.getProfile(accountId)
    return response?.address?.['0']
  }

  validateAddressFields = accountAddress => {
    if (wasValidatedByShippingAddressForm(accountAddress)) {
      return true
    }

    // For locales configured in globalStoreResponse.skipStateValidation (defaults to en_NZ)
    const locale = getLocaleCodeFromUrl() || ''
    const isValidState = isStateValidationSkippedForCountry(locale)
      ? true
      : accountAddress?.state || ''
    // When isLastNameOptional is true, lastName is not required
    const isLastNameOptional = isFeatureEnabled('isLastNameOptional')
    const isValidLastName = isLastNameOptional
      ? true
      : accountAddress?.lastName || ''
    /*  CX115-3650 - For Colombia, Peru and Chile region, zip is optional */
    const isZipCodeOptional = isPostalCodeBlank(accountAddress?.zip)
      ? locale === 'es_CO' ||
        locale === 'es_PE' ||
        locale === 'es_CL' ||
        isPostalCodeOptionalByShippingAddressForm(accountAddress)
      : false
    const hasRequiredAddressFields =
      accountAddress &&
      accountAddress.addressLine1 &&
      accountAddress.firstName &&
      isValidLastName &&
      accountAddress.city &&
      isValidState

    if (hasRequiredAddressFields && (isZipCodeOptional || accountAddress.zip)) {
      return true
    } else {
      toastState.setToastMessage(
        i18nTranslate(
          'addressBook.invalidAddress',
          'Invalid address, please add a new address or update the existing address'
        )
      )
      return false
    }
  }

  validateCommunicationPreferences = accountAddress => {
    let isValid = true
    let isOptionalPhone = isToHaveOptionalPhoneSchema('checkout') || false
    if (!accountAddress?.phone && !isOptionalPhone) {
      toastState.setToastMessage(
        i18nTranslate('addressBook.invalidPhone', 'Please enter contact number')
      )
      isValid = false
    } else if (!accountAddress?.email) {
      toastState.setToastMessage(
        i18nTranslate('validation.emailErrorText', 'Please enter email')
      )
      isValid = false
    }
    return isValid
  }

  checkCommunicationPreference = async () => {
    const communicationResponse =
      await checkoutContainer.setCommunicationPreferenceForZeroCheckout()
    let isError = false
    if (!checkoutContainer.isSuccessResponse(communicationResponse)) {
      toastState.setToastMessage(
        communicationResponse?.message || communicationResponse?.errorMessage
      )
      isError = true
      this.isToDisableShippingContinueBtn = false
    }
    return isError
  }
  /**
   * Checks if the API response indicates "Items not deliverable" error
   */
  isItemsNotDeliverableError = response => {
    const errorMessage = (response?.message || '').toLowerCase()

    // Check main message
    if (errorMessage.includes('items not deliverable')) {
      return true
    }

    // Check errors array
    const hasErrorsArrayMatch = response?.errors?.some(error => {
      const errorMessageInArray = (error?.message || '').toLowerCase()
      return errorMessageInArray.includes('items not deliverable')
    })

    return hasErrorsArrayMatch
  }

  handleAddressContinue = async formData => {
    if (isExpressCheckout()) {
      this.shippingMethodAdded = false
      overlayState?.showLoader()
    }
    this.isToDisableShippingContinueBtn = true
    const { onContinue, title } = this.props
    const products = cartContainer?.cartResponse?.items || []
    trackEnhancedCheckout({
      type: 'checkout',
      action: { step: '1', option: title },
      products: products,
    })
    if (!formData.email) {
      formData.email = customerContainer.profileResponse.email
    }

    if (formData.country === 'IN') {
      if (formData.pinCode && !formData.zip) {
        formData.zip = formData.pinCode
      }
      if (formData.district && !formData.county) {
        formData.county = formData.district
      }
    }

    const isToValidateAddress = shouldMakeLegacyAddressValidationApiCall(
      formData,
      storeContainer?.defaultShippingRegion
    )
    let isToSkipValidation = !isToValidateAddress

    if (
      isExpressCheckout() &&
      addressContainer?.isFirstAddress &&
      !formData.setDefaultAddress
    ) {
      formData.setDefaultAddress = true
    }
    // Address is getting patched even when field like phone number are missing in chile
    // hence isToSkipValidation is removed
    //   if (
    // (this.validateAddressFields(formData) &&
    //   this.validateCommunicationPreferences(formData)) ||
    // isToSkipValidation)

    if (
      this.validateAddressFields(formData) &&
      this.validateCommunicationPreferences(formData)
      // || isToSkipValidation
    ) {
      formData = removeShippingAddressFormValidationMeta(formData)
      let response = await checkoutContainer.setShippingAddress(formData)

      // Check for "Items not deliverable" error specifically for India
      if (!checkoutContainer.isSuccessResponse(response)) {
        const isIndianAddress = formData.country === 'IN'
        if (isPatchAddressAfterCartSuccess()) {
          if (isIndianAddress && this.isItemsNotDeliverableError(response)) {
            if (checkoutContainer.isEditAddressFormEnabled) {
              checkoutContainer.isItemsNotDeliverableErrorIN = true
            }
            checkoutContainer.disableSubmitButtonAsItemsNotDeliverable = true
            const customErrorMessage = i18nTranslate(
              'address.deliveryNotAvailableIndia',
              'Sorry, we do not deliver to your selected location. Please update your pin code and try again.'
            )

            // Track pincode error for GTM
            trackPincodeError({
              pincodeMsg: customErrorMessage,
            })

            // Show toast message
            toastState.setToastMessage(customErrorMessage, false)

            if (isExpressCheckout()) {
              checkoutContainer.isShippingContinueClicked = false
              this.setState({ isAddressNotAdded: true })
              overlayState?.hideLoader()
            }

            this.isToDisableShippingContinueBtn = false
            return
          }

          // Check for invalid phone number error (EOCARCP0003)
          if (response?.code === 'EOCARCP0003') {
            const phoneErrorMessage = i18nTranslate(
              'address.invalidPhoneShipping',
              'Please update your phone number. Enter an Indian phone number to help our shipping carrier better serve you in delivering your order.'
            )

            toastState.setToastMessage(phoneErrorMessage, false)

            if (isExpressCheckout()) {
              checkoutContainer.isShippingContinueClicked = false
              this.setState({ isAddressNotAdded: true })
              overlayState?.hideLoader()
            }

            this.isToDisableShippingContinueBtn = false
            return
          }
        }
      }

      let isSubscriptionCheckoutPage =
        isSubscriptionOverrideCheckoutPage() || false
      response?.items?.length > 0 &&
        response?.items?.forEach(item => {
          item &&
            item.skus &&
            item.skus?.map(bundleItem => {
              let inventoryProperties = bundleItem.inventoryProperties
              if (
                (inventoryProperties?.available === false &&
                  inventoryProperties?.backOrdered === true) ||
                (inventoryProperties?.available === false &&
                  inventoryProperties?.backOrdered === false) ||
                (inventoryProperties?.available === false &&
                  inventoryProperties?.backOrdered === null)
              ) {
                toastState.setToastMessage(
                  i18nTranslate(
                    'checkout.backOrder',
                    'Item got backordered or OOS'
                  ),
                  false
                )
                if (isSubscriptionCheckoutPage) {
                  this.redirectToSubscriptionCartTimer = setTimeout(() => {
                    let originUrl =
                      window?.location?.href?.split('/subscriptionCheckout') ||
                      []
                    window.location.replace(
                      `${originUrl?.[0]}${pageNames?.subscriptionCart}`
                    )
                  }, 1000)
                } else {
                  this.redirectToCartTimer = setTimeout(() => {
                    let originUrl =
                      window?.location?.href?.split(pageNames.checkout) ||
                      window?.location?.href?.split(
                        pageNames.expressCheckout
                      ) ||
                      []
                    window.location.replace(
                      `${originUrl?.[0]}${pageNames?.viewCart}`
                    )
                  }, 1000)
                }
              }
            })
        })
      isPromoWalletEnabled() &&
        (await cartContainer.promoCodeList({
          fetchAllPromoCodes: showAllPromoCodesInCheckout() ? 'true' : 'false',
        }))
      if (checkoutContainer.isSuccessResponse(response)) {
        // checkoutContainer.setCommunicationPreferenceForZeroCheckout()
        if (isPatchAddressAfterCartSuccess()) {
          checkoutContainer.isItemsNotDeliverableErrorIN = false
          checkoutContainer.disableSubmitButtonAsItemsNotDeliverable = false
          const updateAddressAfterCartSuccess =
            this.updateAddressAfterCartSuccess
          this.updateAddressAfterCartSuccess = null
          if (typeof updateAddressAfterCartSuccess === 'function') {
            updateAddressAfterCartSuccess()
          }
        }
        const isErrorInPreference = await this.checkCommunicationPreference()

        if (
          isToShowLegalAddressOptionInAddressForm() &&
          checkoutContainer.isLegalAddressSameAsShipping === 'true'
        ) {
          this.patchShippingAddressAsLegalAddress()
        }
        if (isExpressCheckout()) {
          overlayState?.hideLoader()
        }
        if (isErrorInPreference) {
          return
        }
        if (isExpressCheckout()) {
          this.shippingMethodAdded = true
          checkoutContainer.initiallySelectedAddress =
            response?.deliveryDetails?.address
          checkoutContainer.isShippingContinueClicked = true
          checkoutContainer.isShippingAddNewFormOpen = false
          if (customerContainer?.isRegisterUser) {
            this.getAddressFromProfile()
          }
        }
        // Address save confirmed - only now may Submit Order react to guest
        // checkout's legal agreement gate (checking the box alone must not).
        accountsContainer.isGuestCheckoutShippingAddressConfirmed = true
        await this.refetchGlobalPaymentOptionsAfterAddressSave()
        onContinue()
      } else {
        toastState.setToastMessage(response.message || response.responseMessage)
        if (isExpressCheckout()) {
          checkoutContainer.isShippingContinueClicked = false
          this.setState({ isAddressNotAdded: true })
          overlayState?.hideLoader()
        }
      }
    } else {
      if (isExpressCheckout()) {
        this.setState({ isAddressNotAdded: true })
        overlayState?.hideLoader()
      }
    }
    this.isToDisableShippingContinueBtn = false
  }

  // GPS payment options can depend on the shipping destination, so re-fetch
  // them whenever the shipping address is updated on the cart.
  refetchGlobalPaymentOptionsAfterAddressSave = async () => {
    if (!isGPSEnabled()) {
      return
    }
    try {
      await checkoutContainer.getGlobalPaymentOptions(
        cartContainer.hasSubscriptionProduct()
      )
    } catch (error) {
      console.error(
        'Failed to refetch GPS payment options after address save:',
        error
      )
    }
  }

  patchShippingAddressAsLegalAddress = async () => {
    const accountAddress =
      accountsContainer?.profileResponse?.addresses?.[0] || {}
    const cartAddress =
      cartContainer.cartResponse?.deliveryDetails?.address || {}
    const { accountId = '', addressId = '' } = accountAddress || {}
    const {
      firstName = '',
      lastName = '',
      email = '',
      phone = '',
      phoneNumber = '',
    } = customerContainer?.profileResponse || {}
    const accountIdFromProfile = customerContainer?.accountId || ''

    const formData = {
      ...cartAddress,
      firstName,
      lastName,
      email,
      phone: phone || phoneNumber,
      setDefaultAddress: cartAddress?.isDefault,
      accountId: accountId || accountIdFromProfile || '',
    }
    let updateAddressResponse
    if (Object.keys(accountAddress)?.length > 0) {
      updateAddressResponse =
        await accountsAddressContainer.updateAccountAddress(
          {
            ...formData,
            addressId,
          },
          false
        )
    } else {
      updateAddressResponse =
        await accountsAddressContainer.addAddress(formData)
    }
    const enabledTaxFreeRegionForShipping = isFeatureEnabled(
      'enabledTaxFreeRegionForShipping'
    )
    if (accountsAddressContainer.isSuccessResponse(updateAddressResponse)) {
      await accountsContainer.getProfile(customerContainer.accountId)
      if (enabledTaxFreeRegionForShipping) {
        await cartContainer.viewCartForTax()
      }
      checkoutContainer.isLegalAddressSameAsShipping = 'false'
      checkoutContainer.isLegalAddressAdded = true
      overlayState.hideLoader()
    } else {
      checkoutContainer.isLegalAddressSameAsShipping = 'false'
      await addressContainer.getProfileAddress()
      checkoutContainer.isLegalAddressAdded = false
      overlayState.hideLoader()
    }
  }
  setIsAddressNotAdded = val => {
    this.setState({ isAddressNotAdded: val })
  }

  handleModalConuBtn = async () => {
    await addressContainer.addAddress(this.state.selectedAddress)
    this.setState({
      show: false,
    })
  }

  handleClose() {
    this.setState({
      show: false,
    })
    if (isExpressCheckout()) {
      this.setState({
        isAddressNotAdded: true,
      })
    }
  }
  handleAddressAfterCartSuccess = callback => {
    this.updateAddressAfterCartSuccess = callback
  }
  handleClickOnPro = async dataAfterValidation => {
    dataAfterValidation.type = 'shipping'
    if (dataAfterValidation.selectedIndex <= 0) {
      const response =
        await addressContainer.validateSignUpOriginalAddress(
          dataAfterValidation
        )
      if (response && response.status !== 'failure') {
        dataAfterValidation.addressId = response.addressId
        this.setState(
          {
            show: false,
          },
          () => {
            this.handleAddressContinue(dataAfterValidation)
          }
        )
      } else {
        this.setState({
          show: false,
        })
      }
    } else {
      /**
       * @note
       * Checkout - As per BE Confirmation, removed Add Address API while adding New Shipping Address,
       * as Address will be automatically added to Profile from USER Address Patch API for Registered Users
       */
      this.setState(
        {
          show: false,
        },
        () => {
          this.handleAddressContinue(dataAfterValidation)
          if (isExpressCheckout()) {
            this.shippingMethodAdded = false
          }
        }
      )
    }
  }
  validationCallback = () => {
    this.getAddressFromProfile()
  }
  render() {
    const defaultCountry = storeContainer?.defaultShippingRegion || ''
    const isNLXXMarket = nlxxConfigContainer.enableNLXX
    const nlxxAllowedCodes = nlxxConfigContainer.nlxxAllowedCodes
    const nlxxCountryOptions = nlxxConfigContainer.nlxxCountryOptions
    const allowedCountries = isNLXXMarket ? nlxxAllowedCodes : [defaultCountry]

    const filteredAddress = this.addressList
      ? this.addressList.filter(
          data =>
            allowedCountries.includes(data?.country) &&
            data?.type === 'shipping'
        )
      : this.addressList
    if (this.isAddressFromProfile && this.addressList) {
      return (
        <>
          {this.state.show && (
            <AddressValidation
              open={this.state.show}
              addressInvalidFlag={this.state.addressInvalidFlag}
              recommendations={this.state.recommendations}
              handleClose={() => this.handleClose()}
              handleClickOnPro={dataAfterValidation =>
                this.handleClickOnPro(dataAfterValidation)
              }
            />
          )}
          <ShippingAddressListWithForm
            addressList={filteredAddress}
            isAddressChecked={this.props.isAddressChecked}
            addressToSelectOrPrefill={this.cartUpdatedAddress || {}}
            handleAddressSelect={this.handleAddressSelect}
            onContinue={this.props.onContinue}
            toggleMultipleAddress={this.props.toggleMultipleAddress}
            isMultipleAdressActive={this.props.isMultipleAdressActive}
            handleModal={this.handleModal}
            isFromCheckout={true}
            handleAddressContinue={this.handleAddressContinue}
            isAddressNotAdded={this.state.isAddressNotAdded}
            setIsAddressNotAdded={this.setIsAddressNotAdded}
            shippingMethodAdded={this.shippingMethodAdded}
            validationCallback={this.validationCallback}
            isToDisableShippingContinueBtn={this.isToDisableShippingContinueBtn}
            isFromPDP={this.props.isFromPDP}
            updateAddressAfterCartSuccess={this.handleAddressAfterCartSuccess}
          />
        </>
      )
    }

    return <React.Fragment />
  }
}

export { ShippingAccordion }
export default ShippingAccordion
